import { api } from './api';

const makeRoleHeaders = (userRoleUuid) => {
    if (!userRoleUuid) {
        throw new Error('Missing active user role UUID.');
    }

    return {
        'USER-ROLE': userRoleUuid
    };
};

export const listDocumentTags = async ({
    userRoleUuid,
    paginationToken,
    paginationLimit
} = {}) =>
    api.get('/documents/tags', {
        headers: {
            ...makeRoleHeaders(userRoleUuid),
            ...(paginationToken ? { 'PAGINATION-TOKEN': paginationToken } : {}),
            ...(paginationLimit ? { 'PAGINATION-LIMIT': String(paginationLimit) } : {})
        }
    });

export const fetchDocumentTagByUuid = async ({ userRoleUuid, tagUuid }) =>
    api.post(
        '/documents/tags/fetch',
        { tag: tagUuid },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );

export const createDocumentTag = async ({ userRoleUuid, tag }) =>
    api.post(
        '/documents/tags',
        { tag },
        {
            headers: makeRoleHeaders(userRoleUuid)
        }
    );

